import { render, staticRenderFns } from "./listStaff.vue?vue&type=template&id=20cdae30"
import script from "./listStaff.vue?vue&type=script&lang=js"
export * from "./listStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports